import React from 'react';
import { Icon } from './Icon.js';
export const IconDiamond = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M6 3L2 9L12 21L22 9L18 3H6Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconDiamond.js.map